import { ProgrammeStatusType } from '../types';
import { ChipProps } from '@thirdspacelearning/library';

export const statusMap: Record<ProgrammeStatusType, ChipProps['color']> = {
    [ProgrammeStatusType.LIVE]: 'success',
    [ProgrammeStatusType.ARCHIVED]: 'warning',
    [ProgrammeStatusType.TESTING]: 'info',
    [ProgrammeStatusType.DRAFT]: 'default',
};
